import { z } from 'zod';

export const feedbackFormSchema = z.object({
  rating: z.number().min(1).max(5),
  comment: z.string().optional(),
  selectedQuestionIds: z.array(z.string()).min(1, 'Please select at least one option'),
});

export type FeedbackFormData = z.infer<typeof feedbackFormSchema>;

export const RATING_LABELS: Record<number, string> = {
  1: 'Very Bad',
  2: 'Bad',
  3: 'Okay',
  4: 'Good',
  5: 'Excellent',
};

